import { render, staticRenderFns } from "./ButtonsRounded.vue?vue&type=template&id=a73b45e2&"
import script from "./ButtonsRounded.vue?vue&type=script&lang=js&"
export * from "./ButtonsRounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports